import { Box } from '@mui/material'
import { useEffect, useRef } from 'react'
import ChatMessage from './ChatMessage'
import TypingIndicator from './TypingIndicator'

const ChatMessages = ({ messages, isLoading, user }) => {
  const messagesEndRef = useRef(null)

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  return (
    <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', p: 2 }}>
      {messages.map((message) => (
        <ChatMessage key={message.id} message={message} user={user} />
      ))}
      {isLoading && messages.length > 0 && messages[messages.length - 1]?.content === '' && (
        <TypingIndicator />
      )}
      <div ref={messagesEndRef} />
    </Box>
  )
}

export default ChatMessages
